import { Player } from '@lottiefiles/react-lottie-player';
import successData from '../assets/lottie/success.json';
import loadingData from '../assets/lottie/loading.json';
import emptyData from '../assets/lottie/empty.json';

const DATA = { success: successData, loading: loadingData, empty: emptyData };

export default function LottieAnim({ type = 'success', size = 120, loop, className = '' }) {
  const autoLoop = loop !== undefined ? loop : type === 'loading';
  return (
    <Player
      autoplay
      loop={autoLoop}
      src={DATA[type]}
      style={{ width: size, height: size }}
      className={className}
    />
  );
}
